import { createModel } from '@rematch/core';
import type { RootModel } from '.';
import type { CountryRecord } from '@/api/sip/bookmap/countryLangUsingPost';
import { countryLangQueryUsingPost } from '@/api/sip/bookmap/countryLangUsingPost';
import { isEmpty } from 'lodash';
import langMap from '@/locales/langMap';
import { hostNameToEnvMap } from './global';

const BASE_ROUTE = '/afs-sip/repair-info-search';
const initContryList: CountryRecord[] = [];
const defaultLang = hostNameToEnvMap[window.location.hostname].includes('global') ? 'en' : 'zh-CN';
const defaultCountryCode = hostNameToEnvMap[window.location.hostname].includes('global')
  ? 'UK'
  : 'CN';
const LocaleModel = createModel<RootModel>()({
  state: {
    serverLang: '',
    localLang: '',
    countryCode: '',
    baseRoute: '',
    countryList: initContryList,
    isGlobal: false,
    forceChooseLang: false
  },

  reducers: {
    /**
     * /countryCode/langCode
     * 当 langCode 在前端 langMap 不存在时，serverLang 取值 langCode，localLang 使用默认语言
     * /countryCode
     * 当没有 langCode 时，取 langList 第一个，当 langList 不存在时，使用默认国家默认语言路由
     */
    saveCountryList(state, action: { payload: CountryRecord[] }) {
      const { payload } = action;
      const pathname = window.location.pathname;
      const paths = pathname.split('/');
      paths.shift();
      const routeCountryCode: string = paths.shift() ?? '';
      let routeLang: string = paths.shift() ?? '';
      let localLang = routeLang;
      let serverLang = routeLang;
      const countryItem = payload.find(item => {
        if (item.countryCode === routeCountryCode) {
          return true;
        }
        return false;
      });
      if (!countryItem) {
        return {
          ...state,
          countryList: payload || [],
          forceChooseLang: true
        };
      }
      if (isEmpty(routeLang)) {
        window.open(`/${countryItem.countryCode}${BASE_ROUTE}`, '_self');
        return;
      }
      if (routeLang == 'afs-sip' || routeLang == '404') {
        routeLang = '';
        // 没有提供语言，使用 langlist 第一个
        if (countryItem?.langList.length && countryItem?.langList[0].langCode) {
          serverLang = countryItem?.langList[0].langCode;
        } else {
          window.open(`/${defaultCountryCode}/${defaultLang}${BASE_ROUTE}`, '_self');
          return;
        }
      }
      localLang = serverLang;
      if (!langMap[serverLang]) {
        localLang = defaultLang;
      }
      const baseRoute =
        isEmpty(routeLang) || localLang !== routeLang
          ? `/${routeCountryCode}`
          : `/${routeCountryCode}/${routeLang}`;
      return {
        ...state,
        serverLang: serverLang,
        localLang: localLang,
        baseRoute: baseRoute,
        countryCode: routeCountryCode,
        isGlobal: routeCountryCode !== 'CN',
        countryList: payload || []
      };
    }
  },

  effects: () => ({
    async fetchContryLang() {
      const { code, data } = await countryLangQueryUsingPost();
      if (code !== 200) {
        return {};
      }
      const response = {
        ...data
      };
      this.saveCountryList({
        payload: response.countryList
      });
      return response;
    }
  })
});

export default LocaleModel;
